import React, { useState, useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import { FaWhatsapp } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateSetting,
  getLeadStatusesWithPagination,
  addLeadStatus,
  updateLeadStatus,
  deleteLeadStatus,
  getSetting,
  getWhatsAppMessage,
  updateWhatsAppMessage,
  addWhatsAppMessage,
  deleteWhatsAppMessage,
  updateVoiceAIDetails,
  createVoiceAIDetails,
  getVoiceAIStatus,
  deleteVoiceAIStatus,
  updateVoiceAIStatus,
  createVoiceAIStatus,
} from '../../../redux/actions/Setting.action';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import axios from 'axios';
import { BASEURL } from '../../../baseUrl';
import profile from '../../../assets/img/Sculpt-logo.png';
export default function Setting() {
  const dispatch = useDispatch();
  const [accessToken, setAccessToken] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedLeadStatus, setSelectedLeadStatus] = useState(null);
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [voiceAIValues, setVoiceAIValues] = useState({
    OMNIDIM_API_KEY: '',
    OMNIDIM_DEFAULT_PHONE_NUMBER_ID: '',
    OMNIDIM_BASE_URL: '',
  });

  const [whatsappMessages, setWhatsappMessages] = useState([]);
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [isEditingWhatsapp, setIsEditingWhatsapp] = useState(false);
  const [selectedWhatsappMessage, setSelectedWhatsappMessage] = useState(null);
  const [whatsappPage, setWhatsappPage] = useState(1);
  const [whatsappRowsPerPage, setWhatsappRowsPerPage] = useState(10);
  const [totalWhatsappPages, setTotalWhatsappPages] = useState(1);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState({ type: '', id: null });

  const { leadStatuses, totalPages, getAllWhatsAppMessage } = useSelector(
    (state) => state.setting,
  );
  const getSettings = useSelector((state) => state.setting);
  const voiceAIDetails = useSelector((state) => state.setting.voiceAIDetails);
  const voiceAIStatusList = useSelector((state) => state.setting.voiceAIStatus);
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [editVoice, setEditVoice] = useState(null);

  const [logo, setLogo] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    dispatch(getSetting());
    dispatch(getVoiceAIStatus());
  }, []);

  useEffect(() => {
    if (voiceAIDetails) {
      setVoiceAIValues({
        OMNIDIM_API_KEY: voiceAIDetails?.OMNIDIM_API_KEY || '',
        OMNIDIM_DEFAULT_PHONE_NUMBER_ID:
          voiceAIDetails?.OMNIDIM_DEFAULT_PHONE_NUMBER_ID || '',
        OMNIDIM_BASE_URL: voiceAIDetails?.OMNIDIM_BASE_URL || '',
      });
    }
  }, [voiceAIDetails]);

  useEffect(() => {
    dispatch(getLeadStatusesWithPagination(mainPage, rowsPerPage));
  }, [dispatch, mainPage, rowsPerPage]);

  useEffect(() => {
    dispatch(getWhatsAppMessage(whatsappPage, whatsappRowsPerPage))
      .then((res) => {
        if (res?.status === 200) {
          setWhatsappMessages(res?.data || []);
          setTotalWhatsappPages(res?.data?.totalPages || 1);
        }
      })
      .catch((err) => {
        toast.error('Failed to load WhatsApp messages');
        console.error(err);
      });
  }, [dispatch, whatsappPage, whatsappRowsPerPage]);

  const handleUpdateSetting = () => {
    if (!accessToken.trim()) {
      toast.error('Access Token cannot be empty');
      return;
    }
    const payload = { facebookPageAccessToken: accessToken };
    dispatch(updateSetting(payload))
      .then(() => toast.success('Access Token updated successfully!'))
      .catch((error) => {
        toast.error('Failed to update Access Token');
        console.error('Update Setting Error:', error);
      });
  };

  const handleUpdateVoiceAI = async () => {
    try {
      const payload = {
        OMNIDIM_API_KEY: voiceAIValues.OMNIDIM_API_KEY,
        OMNIDIM_DEFAULT_PHONE_NUMBER_ID:
          voiceAIValues.OMNIDIM_DEFAULT_PHONE_NUMBER_ID,
        OMNIDIM_BASE_URL: voiceAIValues.OMNIDIM_BASE_URL,
      };

      const existingId = getSettings?.getSetting?.getSetting?._id;

      if (existingId) {
        // Update
        const res = await dispatch(updateVoiceAIDetails(existingId, payload));
        toast.success('Voice AI details updated successfully!');
        dispatch(getSetting());
      } else {
        // Create
        const res = await dispatch(createVoiceAIDetails(payload));
        toast.success('Voice AI details created successfully!');
        dispatch(getSetting());
      }
    } catch (error) {
      console.log('Something went wrong!');
    }
  };

  const handlePageChange = (selected) => {
    setMainPage(selected.selected + 1);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setMainPage(1);
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    backgroundColor: Yup.string().required('Background Color is required'),
  });

  const whatsappValidationSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    message: Yup.string().required('Message is required'),
  });

  const handleAddOrUpdateLeadStatus = async (values, { resetForm }) => {
    try {
      if (isEditing) {
        await dispatch(updateLeadStatus(selectedLeadStatus._id, values));
      } else {
        await dispatch(addLeadStatus(values));
      }
      resetForm();
      setShowModal(false);
      dispatch(getLeadStatusesWithPagination(mainPage, rowsPerPage));
    } catch (error) {
      toast.error('Failed to process Lead Status');
    }
  };

  const openEditModal = (status) => {
    setSelectedLeadStatus(status);
    setIsEditing(true);
    setShowModal(true);
  };

  const handleDeleteLeadStatus = (id) => {
    setDeleteItem({ type: 'leadStatus', id });
    setShowDeleteModal(true);
  };

  const handleDeleteVoiceAiLeadStatus = (id) => {
    setDeleteItem({ type: 'voiceAI', id });
    setShowDeleteModal(true);
  };

  const handleAddOrUpdateWhatsapp = async (values, { resetForm }) => {
    try {
      if (isEditingWhatsapp) {
        const payload = {
          title: values.title,
          description: values.message,
        };
        await dispatch(
          updateWhatsAppMessage(selectedWhatsappMessage._id, payload),
        );
      } else {
        const payload = {
          title: values.title,
          description: values.message,
        };
        await dispatch(addWhatsAppMessage(payload));
      }

      // Refresh list
      dispatch(getWhatsAppMessage(whatsappPage, whatsappRowsPerPage)).then(
        (res) => {
          setWhatsappMessages(res?.data || []);
          setTotalWhatsappPages(res?.data?.totalPages || 1);
        },
      );

      resetForm();
      setShowWhatsappModal(false);
      setIsEditingWhatsapp(false);
      setSelectedWhatsappMessage(null);
    } catch (error) {
      toast.error('Failed to save WhatsApp message');
      console.error('Save WhatsApp Message Error:', error);
    }
  };

  const handleWhatsappPageChange = (selected) => {
    setWhatsappPage(selected.selected + 1);
  };

  const handleWhatsappRowsChange = (e) => {
    setWhatsappRowsPerPage(Number(e.target.value));
    setWhatsappPage(1);
  };

  const handleDeleteWhatsappMessage = (id) => {
    setDeleteItem({ type: 'whatsapp', id });
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (deleteItem.type === 'leadStatus') {
      dispatch(deleteLeadStatus(deleteItem.id))
        .then(() => {
          dispatch(getLeadStatusesWithPagination(mainPage, rowsPerPage));
        })
        .catch((error) => {
          toast.error('Failed to delete lead status');
          console.error('Delete Lead Status Error:', error);
        });
    } else if (deleteItem.type === 'whatsapp') {
      dispatch(deleteWhatsAppMessage(deleteItem.id))
        .then(() => {
          dispatch(getWhatsAppMessage(whatsappPage, whatsappRowsPerPage)).then(
            (res) => {
              setWhatsappMessages(res?.data || []);
              setTotalWhatsappPages(res?.data?.totalPages || 1);
            },
          );
        })
        .catch((err) => {
          toast.error('Failed to delete WhatsApp message');
          console.error('Delete error:', err);
        });
    } else if (deleteItem.type === 'voiceAI') {
      dispatch(deleteVoiceAIStatus(deleteItem.id))
        .then(() => {
          dispatch(getVoiceAIStatus());
          toast.success('Voice AI Status deleted');
        })
        .catch(() => toast.error('Failed to delete Voice AI Status'));
    }

    setShowDeleteModal(false);
    setDeleteItem({ type: '', id: null });
  };

  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setLogo(previewUrl);
      setSelectedFile(file);

      const formData = new FormData();
      formData.append('logo', file);

      try {
        const token = localStorage.getItem('token');
        const response = await axios.put(
          `${BASEURL}/Setting/updateSetting`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          },
        );

        if (response.data.success) {
          toast.success('Logo updated successfully!');
          dispatch(getSetting());
        } else {
          toast.error('Failed to update logo');
          // Reset preview on failure
          setLogo(null);
          setSelectedFile(null);
        }
      } catch (error) {
        console.error('Error uploading logo:', error);
        toast.error('Failed to update logo');
        // Reset preview on error
        setLogo(null);
        setSelectedFile(null);
      }
    }
  };

  // Cleanup preview URL when component unmounts
  useEffect(() => {
    return () => {
      if (logo) {
        URL.revokeObjectURL(logo);
      }
    };
  }, [logo]);

  return (
    <div className="mt-[100px]">
      <h4 className="font-bold">Facebook Page Access Token</h4>
      <div className="d-flex">
        <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2">
          <input
            type="text"
            name="AccessToken"
            className="w-full outline-none"
            placeholder="Access Token"
            value={accessToken}
            onChange={(e) => setAccessToken(e.target.value)}
          />
        </div>
        <Button
          className="!bg-theme-dark fw-bold d-flex align-items-center border-0"
          onClick={handleUpdateSetting}
        >
          <IoMdAdd className="mt-1 gap-1" />
          {getSettings?.getSetting?.facebookPageAccessToken
            ? 'Update Access Token'
            : 'Add Access Token'}
        </Button>
      </div>
      {/* <div className="flex flex-col mb-6 mt-[25px]">
                <h2 className="fw-bold">Logo Name</h2>  
                <div className="bg-white p-4 rounded-lg shadow-md">
                    Show current logo from settings 
                    {getSettings?.getSetting?.getSetting?.logo && !logo && (
                        <div className="mb-4">
                            <img 
                                src={getSettings.getSetting.getSetting.logo} 
                                alt="Current Company Logo" 
                                className="h-12 w-auto object-contain"
                                onError={(e) => {
                                    console.error("Error loading logo:", e);
                                    e.target.onerror = null;
                                    e.target.src = profile;
                                }}
                            />
                                                    </div>
                    )}
                    
                     Show preview of new logo 
                    {logo && (
                        <div className="mb-4">
                            <p className="text-sm text-gray-600 mb-2">Preview:</p>
                            <img 
                                src={logo} 
                                alt="New Logo Preview" 
                                className="h-12 w-auto object-contain"
                                onError={(e) => {
                                    console.error("Error loading preview:", e);
                                    e.target.onerror = null;
                                    e.target.src = profile;
                                }}
                            />
                        </div>
                    )}

                    <label htmlFor="logo-upload" className="cursor-pointer inline-block">
                        <div className="flex items-center gap-2 bg-theme-dark text-white px-4 py-2 rounded-md hover:bg-opacity-90 transition-colors">
                            <IoMdAdd />
                            <span>Upload Logo</span>
                        </div>
                    </label>
                    <input 
                        type="file" 
                        accept="image/*" 
                        onChange={handleLogoChange} 
                        className="hidden" 
                        id="logo-upload" 
                    />
                    {selectedFile && (
                        <div className="mt-2 text-sm text-gray-600">
                            <strong>Selected file:</strong> {selectedFile.name}
                        </div>
                    )}
                </div>
            </div> */}
      <div className="mt-[50px] mb-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="fw-bold">Lead Statuses</h3>
          <div>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
          <Button
            className="!bg-theme-dark fw-bold d-flex align-items-center border-0"
            onClick={() => {
              setIsEditing(false);
              setSelectedLeadStatus(null);
              setShowModal(true);
            }}
          >
            <IoMdAdd className="mt-1 gap-1" />
            Add Lead Status
          </Button>
        </div>

        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Title</Th>
                <Th>Background Color</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {leadStatuses.length > 0 ? (
                leadStatuses.map((status) => (
                  <Tr key={status._id}>
                    <Td>{status.title}</Td>
                    <Td>
                      <div
                        style={{
                          backgroundColor: status.backgroundColor,
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                        }}
                      ></div>
                    </Td>
                    <Td
                      style={{
                        position: 'sticky',
                        right: 0,
                        background: '#fff',
                        zIndex: 9,
                      }}
                    >
                      <div className="d-flex gap-2 fs-6 fw-bold">
                        <FaEdit
                          className="text-success"
                          onClick={() => openEditModal(status)}
                        />
                        Edit
                        <FaTrashAlt
                          className="text-danger cursor-pointer"
                          title="Delete"
                          onClick={() => handleDeleteLeadStatus(status._id)}
                        />
                        Delete
                      </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="3" className="text-center">
                    No Lead Statuses Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      {/* Pagination */}
      <ReactPaginate
        breakLabel="..."
        nextLabel="Next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={5}
        pageCount={totalPages || 1}
        previousLabel="< Previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      <div className="mt-[50px]">
        <div className="flex justify-between items-center mb-3">
          <h3 className="fw-bold">Voice AI Status</h3>

          <Button
            className="!bg-theme-dark d-flex align-items-center border-0 fw-bold"
            onClick={() => {
              setEditVoice(null);
              setShowVoiceModal(true);
            }}
          >
            <IoMdAdd /> Add Voice Status
          </Button>
        </div>

        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Title</Th>
                <Th>Background</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {voiceAIStatusList?.voiceAIStatus?.length > 0 ? (
                voiceAIStatusList.voiceAIStatus.map((item) => (
                  <Tr key={item._id}>
                    <Td>{item.title}</Td>
                    <Td>
                      <div
                        style={{
                          background: item.backgroundColor,
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                        }}
                      ></div>
                    </Td>
                    <Td
                      style={{
                        position: 'sticky',
                        right: 0,
                        background: '#fff',
                        zIndex: 9,
                      }}
                    >
                      <div className="d-flex gap-2 fs-6 fw-bold">
                        <FaEdit
                          className="text-success"
                          onClick={() => {
                            setEditVoice(item);
                            setShowVoiceModal(true);
                          }}
                        />
                        Edit
                        <FaTrashAlt
                          className="text-danger cursor-pointer"
                          title="Delete"
                          onClick={() =>
                            handleDeleteVoiceAiLeadStatus(item._id)
                          }
                        />
                        Delete
                      </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="3" className="text-center">
                    No Voice AI Status Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      <Modal show={showVoiceModal} onHide={() => setShowVoiceModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editVoice ? 'Edit Voice AI Status' : 'Add Voice AI Status'}
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{
            title: editVoice?.title || '',
            backgroundColor: editVoice?.backgroundColor || '#000000',
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            if (editVoice) {
              await dispatch(updateVoiceAIStatus(editVoice._id, values));
              toast.success('Voice AI Status updated successfully');
            } else {
              await dispatch(createVoiceAIStatus(values));
              toast.success('Voice AI Status created successfully');
            }
            dispatch(getVoiceAIStatus());
            setShowVoiceModal(false);
          }}
          enableReinitialize
        >
          {({ handleSubmit }) => (
            <FormikForm onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Field
                    type="text"
                    name="title"
                    className="form-control"
                    placeholder="Enter title"
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Background Color</Form.Label>
                  <Field
                    type="color"
                    name="backgroundColor"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="backgroundColor"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowVoiceModal(false)}>Close</Button>
                <Button type="submit" className="!bg-theme-dark border-0">
                  {editVoice ? 'Update' : 'Add'}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      {/* VoiceAI Details */}
      <div className="mt-[40px]">
        <h4 className="font-bold mb-3">VoiceAI Details</h4>

        <div className="d-flex flex-column gap-3 bg-white shadow-shadows p-4 rounded-lg">
          {/* OMNIDIM_API_KEY */}
          <div>
            <label className="font-semibold">OMNIDIM API Key</label>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Enter OMNIDIM API Key"
              value={voiceAIValues.OMNIDIM_API_KEY}
              onChange={(e) =>
                setVoiceAIValues((prev) => ({
                  ...prev,
                  OMNIDIM_API_KEY: e.target.value,
                }))
              }
            />
          </div>

          {/* OMNIDIM_DEFAULT_PHONE_NUMBER_ID */}
          <div>
            <label className="font-semibold">Default Phone Number ID</label>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Enter Default Phone Number ID"
              value={voiceAIValues.OMNIDIM_DEFAULT_PHONE_NUMBER_ID}
              onChange={(e) =>
                setVoiceAIValues((prev) => ({
                  ...prev,
                  OMNIDIM_DEFAULT_PHONE_NUMBER_ID: e.target.value,
                }))
              }
            />
          </div>

          {/* OMNIDIM_BASE_URL */}
          <div>
            <label className="font-semibold">Base URL</label>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Enter Base URL"
              value={voiceAIValues.OMNIDIM_BASE_URL}
              onChange={(e) =>
                setVoiceAIValues((prev) => ({
                  ...prev,
                  OMNIDIM_BASE_URL: e.target.value,
                }))
              }
            />
          </div>

          {/* Save button */}
          <Button
            className="!bg-theme-dark fw-bold border-0 mt-3"
            onClick={handleUpdateVoiceAI}
          >
            Save Voice AI Details
          </Button>
        </div>
      </div>

      {/* WhatsApp Messages Section */}
      <div className="mt-[50px] mb-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="fw-bold">WhatsApp Message Templates</h3>
          <div className="flex items-center gap-3">
            Rows per page:
            <select
              value={whatsappRowsPerPage}
              onChange={handleWhatsappRowsChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
            </select>
          </div>
          <Button
            className="!bg-theme-dark fw-bold d-flex align-items-center border-0"
            onClick={() => {
              setIsEditingWhatsapp(false);
              setSelectedWhatsappMessage(null);
              setShowWhatsappModal(true);
            }}
          >
            <IoMdAdd className="mt-1 gap-1" />
            Add WhatsApp Message
          </Button>
        </div>

        <TableContainer>
          <Table variant="striped" colorScheme="green">
            <Thead>
              <Tr>
                <Th>Title</Th>
                <Th>Message</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {getAllWhatsAppMessage?.data?.length > 0 ? (
                getAllWhatsAppMessage?.data?.map((msg) => (
                  <Tr key={msg?._id}>
                    <Td>{msg?.title}</Td>
                    <Td
                      style={{
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                      }}
                    >
                      {msg?.description}
                    </Td>
                    <Td>
                      <div className="d-flex gap-2 fs-6 fw-bold">
                        <FaEdit
                          className="text-success"
                          onClick={() => {
                            setIsEditingWhatsapp(true);
                            setSelectedWhatsappMessage(msg);
                            setShowWhatsappModal(true);
                          }}
                        />{' '}
                        Edit
                        <FaTrashAlt
                          className="text-danger cursor-pointer"
                          title="Delete"
                          onClick={() => handleDeleteWhatsappMessage(msg._id)}
                        />{' '}
                        Delete
                      </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="3">No WhatsApp Messages</Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>

        <ReactPaginate
          breakLabel="..."
          nextLabel="Next >"
          onPageChange={handleWhatsappPageChange}
          pageRangeDisplayed={3}
          pageCount={totalWhatsappPages}
          previousLabel="< Previous"
          className="pagination"
        />
      </div>

      {/* Modal for Add/Edit Lead Status */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Edit' : 'Add'} Lead Status</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            title: selectedLeadStatus?.title || '',
            backgroundColor: selectedLeadStatus?.backgroundColor || '#000000',
          }}
          validationSchema={validationSchema}
          onSubmit={handleAddOrUpdateLeadStatus}
          enableReinitialize
        >
          {({ handleSubmit }) => (
            <FormikForm onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Field
                    type="text"
                    name="title"
                    className="form-control"
                    placeholder="Enter title"
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Background Color</Form.Label>
                  <Field
                    type="color"
                    name="backgroundColor"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="backgroundColor"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Close
                </Button>
                <Button type="submit" className="!bg-theme-dark border-0">
                  {isEditing ? 'Update' : 'Add'}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>
      {/* WhatsApp Modal */}
      <Modal
        show={showWhatsappModal}
        onHide={() => setShowWhatsappModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditingWhatsapp ? 'Edit' : 'Add'} WhatsApp Message
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            title: selectedWhatsappMessage?.title || '',
            message: selectedWhatsappMessage?.description || '',
          }}
          validationSchema={whatsappValidationSchema}
          onSubmit={handleAddOrUpdateWhatsapp}
          enableReinitialize
        >
          {({ handleSubmit }) => (
            <FormikForm onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Field type="text" name="title" className="form-control" />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Field
                    as="textarea"
                    name="message"
                    className="form-control"
                    rows={3}
                  />
                  <ErrorMessage
                    name="message"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowWhatsappModal(false)}
                >
                  Close
                </Button>
                <Button type="submit" className="!bg-theme-dark border-0">
                  {isEditingWhatsapp ? 'Update' : 'Add'}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        backdrop="static"
        className="delete-modal"
      >
        <div className="bg-white rounded-lg p-8 max-w-md w-full mx-auto relative shadow-xl">
          <button
            onClick={() => setShowDeleteModal(false)}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-200"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 mb-6">
              <svg
                className="h-10 w-10 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Delete Confirmation
            </h3>
            <p className="text-base text-gray-600 mb-8">
              Are you sure you want to delete this{' '}
              {deleteItem.type === 'leadStatus'
                ? 'lead status'
                : 'WhatsApp message'}
              ? This action cannot be undone.
            </p>
            <div className="flex justify-center space-x-6 mt-8">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-6 py-2 text-base font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-6 py-2 text-base font-medium text-white bg-red-600 hover:bg-red-700 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <style jsx>{`
        .delete-modal .modal-content {
          background: transparent;
          border: none;
        }
        .delete-modal .modal-backdrop {
          background-color: rgba(0, 0, 0, 0.75);
        }
        .delete-modal .modal-dialog {
          margin: 1.75rem auto;
          max-width: 32rem;
        }
      `}</style>
    </div>
  );
}
